import React from "react";

import * as yup from "yup";
import {
    SitePricing,
    SitePricingQueryQuery,
    useSitePricingQueryQuery,
    useSitePricingsMutationMutation
} from "../../generated/graphql";
import {ListEditor} from "../../components/list-editor";
import {useLocation} from "react-router";
import { uniqueId } from "../../utils";
import { FieldTableColumnProps } from "../../components/FieldTable/FieldTableTypes";


const columns:FieldTableColumnProps<SitePricing>[] = [{
    header: 'Code',
    accessor: 'label',
    dataType:'text'
}, {
    header: 'Panel Price',
    accessor: 'panel',
    dataType: 'currency',
    options: {
        currency: {
            accessor:'currency'
        }
    }
}, {
    header: 'Comment',
    accessor: 'comment',
    className:'column-width-wide-plus',
    dataType:'text'
}
];


function newRow():SitePricing {
    return {
        id:uniqueId(),
        label:'',
        panel:0,
        comment:''
    }
}

const schema =  yup.array().of(yup.object().shape({
        label: yup.string().min(1),
        panel: yup.number().required()
    }));

function getValues(data:SitePricingQueryQuery): SitePricing[] {
    return data?.sitePricings;
}

const relations = {
    currency:'connect'
};

const SitePricings = ()=> {
    const url = useLocation().pathname;
    const query = useSitePricingQueryQuery();
    const [mutation,mutationResult] = useSitePricingsMutationMutation();
    return (
        <ListEditor
            saveResult={mutationResult}
            className="site-pricings"
            baseUrl={url}
            getValues={getValues}
            relationships={relations}
           columns={columns}
           validationSchema={schema}
            title="Site Pricing"
            permission="sitepricing"
            query={query}
            mutation={mutation}
            newRow={newRow}
            newRowLabel="Add Site Pricing"
        />);
}

export default SitePricings;
